import { Name as AddToBasketFailedName } from '@ori-events/add-to-basket-failed';
import { Name as NotificationEventName } from '@ori-events/show-error-notification';
import { Alert } from '@ori-ui/mui';
import { useCallback, useEffect, useState } from 'react';
import { useTranslations } from '../hooks/useTranslations';
import { SnackbarError } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_TIMEOUT_DELAY = 3000;
export const ErrorNotification = () => {
  const {
    formatMessage
  } = useTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const genericErrorFormatted = formatMessage('genericError');
  const [message, setMessage] = useState(genericErrorFormatted);
  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);
  const handleShowErrorNotification = event => {
    const {
      message
    } = event.detail;
    const formattedMessage = message ? formatMessage(message) : genericErrorFormatted;
    setMessage(formattedMessage);
    setIsOpen(true);
  };
  const handleAddToBasketFailed = event => {
    const {
      localizedMessage
    } = event.detail;
    setMessage(localizedMessage);
    setIsOpen(true);
  };
  useEffect(() => {
    window.addEventListener(NotificationEventName, handleShowErrorNotification);
    window.addEventListener(AddToBasketFailedName, handleAddToBasketFailed);
    return () => {
      window.removeEventListener(NotificationEventName, handleShowErrorNotification);
      window.removeEventListener(AddToBasketFailedName, handleAddToBasketFailed);
    };
  });
  return /*#__PURE__*/_jsx(SnackbarError, {
    open: isOpen,
    message: message,
    autoHideDuration: DEFAULT_TIMEOUT_DELAY,
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    onClose: handleClose,
    children: /*#__PURE__*/_jsx(Alert, {
      severity: "error",
      variant: "filled",
      children: message
    })
  }, "error");
};